import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ResponsiveScreenService } from '../../services/responsive-screen.service';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-images-section',
    templateUrl: './images-section.component.html',
    styleUrls: ['./images-section.component.scss'],
    standalone: true,
    imports: [NgIf]
})
export class ImagesSectionComponent implements OnInit {
    @ViewChild('imagesSection') imagesSection: ElementRef<HTMLDivElement>;
    private autoScroll = false;
    private previousTimestamps = 0;
    private autoScrollSpeed = 0.03;
    private scrollDirection = 1;
    private previousScrollValue = 0;
    private stableSince = 0;
    private currentScrollAmount = 0;

    constructor(public responsiveScreenService: ResponsiveScreenService) { }

    ngOnInit(): void {
        this.initResizeListener();
        this.updateAutoScrollState();
    }

    private initResizeListener(): void {
        window.addEventListener('resize', () => {
            this.updateAutoScrollState();
        });
    }

    private updateAutoScrollState(): void {
        if (window.innerWidth < this.responsiveScreenService.breakpoints.m.max) {
            if (!this.autoScroll) {
                window.requestAnimationFrame((timestamps) => { this.updateAutoScroll(timestamps); });
                this.previousTimestamps = 0;
                this.autoScroll = true;
            }
        } else {
            this.autoScroll = false;
        }
    }

    private updateAutoScroll(timestamps: number): void {
        if (this.imagesSection?.nativeElement && this.previousTimestamps) {
            const movementAmount = timestamps - this.previousTimestamps;
            const scrollValue = this.imagesSection.nativeElement.scrollLeft;
            const pauseOnSides = 300; // in ms

            if (Math.round(scrollValue) === Math.round(this.previousScrollValue)) {
                this.stableSince += movementAmount;
                if (this.stableSince > pauseOnSides) {
                    this.scrollDirection *= -1;
                    this.stableSince = 0;
                    this.currentScrollAmount = 0;
                }
            }
            else {
                this.stableSince = 0;
            }

            this.currentScrollAmount -= scrollValue - this.previousScrollValue;
            if (Math.abs(scrollValue - this.previousScrollValue) > 2) {
                this.currentScrollAmount = 0;
            }
            const movement = movementAmount * this.autoScrollSpeed * this.scrollDirection;
            this.currentScrollAmount += movement;
            if (this.currentScrollAmount * this.scrollDirection > 0) {
                this.imagesSection.nativeElement.scroll({ left: scrollValue + this.currentScrollAmount });
            }
            this.previousScrollValue = scrollValue;
        }

        this.previousTimestamps = timestamps;
        if (this.autoScroll) {
            window.requestAnimationFrame((time) => { this.updateAutoScroll(time); });
        }
    }
}
